<template>
  <div class="k-page-content">
    <el-tabs v-model="activeName" class="box-eltab">
      <el-tab-pane label="任务列表" name="first">
        <div class="k-page-common">
          <div class="k-common-header">
            <div class="k-filter-option k-filter-input">
              <el-input
                placeholder="请输入账户ID或名称"
                v-model="searchForm.name"
                :size="size"
                clearable
                @blur="doSearch"
              ></el-input>
            </div>
            <div class="k-filter-option k-filter-input">
              <!-- Avoid mutating a prop directly since the value will be overwritten whenever the parent component re-renders. 
              Instead, use a data or computed property based on the prop's value. Prop being mutated: "placement"-->
              <!-- 添加align属性预防以上报错 -->
              <el-date-picker
                align="center"
                :size="size"
                v-model="searchForm.time"
                type="daterange"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @blur="doSearch"
              ></el-date-picker>
            </div>
          </div>
          <div class="k-common-con">
            <div class="k-table-wrapper">
              <div class="k-table-toolbar">
                <div>
                  <!-- <el-button type="primary" :size="size" @click="reset">重置</el-button> -->
                </div>
              </div>
              <div class="k-table-con">
                <el-table :data="tableData.data" border style="width: 100%">
                  <el-table-column prop="id" fixed label="任务ID" width="80"></el-table-column>
                  <el-table-column prop="advertiser_name" label="投放账户" min-width="220"></el-table-column>
                  <el-table-column prop="nickname" label="发布人" width="150"></el-table-column>
                  <el-table-column label="当前状态" width="200">
                    <template slot-scope="scope">
                      <template v-if="scope.row.status == '0'">
                        <el-tag type="info" :size="size" effect="dark">草稿</el-tag>
                      </template>
                      <template v-if="scope.row.status == '1'">
                        <el-tag type="success" :size="size" effect="dark">待投放</el-tag>
                      </template>
                      <template v-if="scope.row.status == '2'">
                        <el-tag type="warning" :size="size" effect="dark">投放中</el-tag>
                      </template>
                      <template v-if="scope.row.status == '3'">
                        <el-tag :size="size" effect="dark">成功</el-tag>
                      </template>
                      <template v-if="scope.row.status == '4'">
                        <el-tag type="danger" :size="size" effect="dark">有失败</el-tag>
                      </template>
                    </template>
                  </el-table-column>
                  <el-table-column prop="nickname" label="进度" min-width="150">
                    <template slot-scope="scope">
                      <span style="font-weight: bold">{{scope.row.successTotal}}/{{scope.row.total}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="create_time" label="创建时间" min-width="200"></el-table-column>
                  <el-table-column fixed="right" label="操作" min-width="100">
                    <template slot-scope="scope">
                      <el-button type="text" :size="size" @click="openLogDialog(scope.row.id)">日志</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  background
                  ref="pagination"
                  @current-change="handleCurrentChange"
                  :current-page="tableData.current_page | number"
                  :page-size="tableData.per_page | number"
                  layout="total, prev, pager, next, jumper"
                  :total="tableData.total | number"
                ></el-pagination>
              </div>
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>

    <el-dialog title="日志详情" width="70%" :visible.sync="dialogTableVisible">
      <el-table :data="infoData.data" border :size="size" style="width: 100%">
        <el-table-column property="id" fixed label="序号" width="80"></el-table-column>
        <el-table-column property="advertiser_name" min-width="250" label="账户"></el-table-column>
        <el-table-column property="name" min-width="250" label="名称"></el-table-column>
        <el-table-column label="操作对象" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.type == 'GROUP'">广告组</span>
            <span v-if="scope.row.type == 'CAMPAIGN'">广告计划</span>
            <span v-if="scope.row.type == 'CREATIVE'">广告创意</span>
          </template>
        </el-table-column>
        <el-table-column property="create_time" min-width="180" label="操作时间"></el-table-column>
        <el-table-column property="code" width="80" label="状态码"></el-table-column>
        <el-table-column property="message" min-width="200" label="备注">
          <template slot-scope="scope">
            <span v-if="scope.row.code != 0" style="color: red">{{scope.row.message}}</span>
            <span v-else style="color: green">成功</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        style="margin-top:10px;"
        background
        ref="pagination"
        @current-change="handleCurrentChange"
        :current-page="infoData.current_page | number"
        :page-size="infoData.per_page | number"
        layout="total, prev, pager, next, jumper"
        :total="infoData.total | number"
      ></el-pagination>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogTableVisible = false" :size="size">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: ['info'],
  data() {
    return {
      timer: '',
      dialogTableVisible: false,
      isCollapse: false,
      activeClass: 'el-icon-s-fold',
      activeName: 'first',
      slidewidth: 160,
      loading: false,
      size: 'mini',
      searchForm: {
        name: '',
        time: []
      },
      resetSearch: {
        name: '',
        time: []
      },
      checked: false,
      tableData: {
        total: 0,
        per_page: 15,
        current_page: 1,
        last_page: 0,
        data: []
      },
      taskId: '',
      infoData: {
        total: 0,
        per_page: 15,
        current_page: 1,
        last_page: 0,
        data: []
      }
    }
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val)
    }
  },
  computed: {
    apiMainHeight: function() {
      var height = window.innerHeight - 200
      return {
        height: height + 'px',
        border: '1px solid #DCDFE6',
        'margin-bottom': '10px'
      }
    }
  },
  methods: {
    // 打开弹窗
    openLogDialog: function(taskId) {
      //home_v1_adver_taskLogList
      this.$api.http
        .get('adPromotion/openLogDialog', {
          taskId: taskId,
          page: this.infoData.current_page
        })
        .then(res => {
          if (res.code === 0) {
            this.infoData = res.data
            this.dialogTableVisible = true
            this.$message({
              showClose: true,
              message: '查询应用列表信息成功！',
              type: 'success'
            })
          } else {
            this.$message({
              showClose: true,
              message: '查询应用列表失败！',
              type: 'error'
            })
          }
        })
    },
    // 获取权限内人员
    getUserInfo: function(query, type) {
      //home_v1_userAdvertisers_user
      this.$api.http
        .get('adPromotion/getUserInfo', { query: query })
        .then(res => {
          if (res.code === 0) {
            if (type == 'account') {
              this.accounts = res.data
            } else if (type == 'collaborator') {
              this.collaborators = res.data
            } else {
              this.accounts = this.collaborators = res.data
            }
          }
        })
    },
    reset: function() {
      this.searchForm = this.resetSearch
      this.doSearch()
    },
    // 执行查询
    doSearch: function(event) {
      this.handleSearch()
    },
    // 排序
    sortChange: function(e) {
      var order
      var prop = e.prop
      if (e.order == 'ascending') {
        order = 'asc'
      } else if (e.order == 'descending') {
        order = 'desc'
      } else {
        prop = this.resetSearch.prop
        order = this.resetSearch.order
      }
      this.handleSearch(1, prop, order)
    },
    // 改变当前页 page
    handleCurrentChange: function(val) {
      this.handleSearch(val)
    },
    // 公共请求接口
    handleSearch: function(page, prop, order) {
      // 如果页面切换则停止计时器
      if (window.location.hash != '#/task') {
        clearInterval(this.timer)
        this.timer = null
      }
      this.loading = true
      var param = {}
      param['name'] = this.searchForm.name
        ? this.searchForm.name
        : this.resetSearch.name
      param['time'] = this.searchForm.time
        ? this.searchForm.time
        : this.resetSearch.time
      param['page'] = page ? page : 1
      param['prop'] = prop ? prop : 'id'
      param['order'] = order ? order : 'desc'
      this.$api.http.get('adPromotion/adverTaskList', param).then(res => {
        if (res.code === 0) {
          this.tableData = res.data
        } else {
          var message = '查询应用列表信息失败！'
          if (res.message) {
            message = res.message
          }
          this.$message({
            showClose: true,
            message: message,
            type: 'error'
          })
        }
        this.loading = false
      })
    },
    // 生成查询参数
    makeParams: function(query, data) {
      var params = {}
      params['name'] = this.searchForm.name
        ? this.searchForm.name
        : this.resetSearch.name
      params['time'] = this.searchForm.time
        ? this.searchForm.time
        : this.resetSearch.time
      this.searchForm = params
      return params
    }
  },
  beforeRouteUpdate: function(to, from, next) {
    var params = this.makeParams(to.query)
    this.handleSearch()
    next()
  },
  mounted: function() {
    var params = this.makeParams()
    this.handleSearch()
    this.timer = setInterval(this.handleSearch, 5000)
  }
}
</script>